import { motion, useReducedMotion } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import { useSettings } from '../../lib/settings';
import { Icons } from '../ui/Icons';
import { Reveal } from '../ui/Reveal';

const CHIPS = [
  { icon: 'heart' as const, label: 'Free & no obligation' },
  { icon: 'shield' as const, label: 'One specialist, never an auction' },
  { icon: 'badge' as const, label: 'CAPS-certified' },
];

export function FinalCta() {
  const { openLeadForm } = useApp();
  const settings = useSettings();
  const reduce = useReducedMotion();

  return (
    <section id="start" className="relative py-20 sm:py-28">
      <div className="container-rosa">
        <div className="relative isolate overflow-hidden rounded-[2.5rem] shadow-lift">
          {/* Warm image + gradient overlay for legibility */}
          <img
            src="/images/living-room-calm.webp"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 -z-20 h-full w-full object-cover"
          />
          <div className="absolute inset-0 -z-10 bg-gradient-to-br from-terracotta/95 via-terracotta-deep/95 to-plum/95" />
          <div className="pointer-events-none absolute inset-0 -z-10 bg-grain opacity-40" />

          {/* Decorative floating orb */}
          <motion.div
            aria-hidden="true"
            className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-blush/10 blur-2xl"
            animate={reduce ? undefined : { y: [0, -18, 0] }}
            transition={{ duration: 7, repeat: Infinity, ease: 'easeInOut' }}
          />

          <div className="relative px-6 py-16 text-center sm:px-12 sm:py-20 lg:px-16">
            <Reveal className="mx-auto max-w-3xl">
              <p className="font-body text-xs font-semibold uppercase tracking-[0.22em] text-blush/70">
                Start today
              </p>
              <h2 className="mt-5 font-display text-[2.4rem] font-bold leading-[1.06] tracking-[-0.01em] text-blush sm:text-5xl lg:text-[3.4rem]">
                The home she loves, safe for the years ahead.
              </h2>
              <p className="mx-auto mt-6 max-w-xl font-body text-lg leading-relaxed text-blush/85">
                One trusted CAPS-certified specialist. A free in-home safety assessment, usually within{' '}
                {settings.response_window_hours} hours. No sales calls, no runaround, no cost to you.
              </p>

              <div className="mt-9 flex justify-center">
                <button
                  onClick={() => openLeadForm()}
                  className="btn-primary bg-blush !px-9 !py-5 text-lg !text-plum hover:bg-white"
                >
                  {settings.primary_cta_label} <Icons.arrowRight width={20} height={20} />
                </button>
              </div>

              <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
                {CHIPS.map((c) => {
                  const I = Icons[c.icon];
                  return (
                    <span key={c.label} className="flex items-center gap-1.5 font-body text-sm font-medium text-blush/85">
                      <I width={17} height={17} className="text-blush" />
                      {c.label}
                    </span>
                  );
                })}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
